export default __webpack_public_path__ + "static/media/BTCbuttonLogo.766fd60c.svg";